import { formatCurrency } from "@/lib/utils"
import type { Repasse } from "../schema"

const Total = ({
    label,
    value,
    foot,
    tone,
}: { label: string; value: number; foot: string; tone?: "ok" | "off" }) => (
    <div className="bg-card px-6 py-4">
        <span className="font-mono text-[0.65rem] uppercase tracking-[0.11em] text-faint">
            {label}
        </span>
        <p
            className={`mt-0.5 text-2xl font-bold tracking-tight tabular-nums ${
                tone === "ok" ? "text-ok" : tone === "off" ? "text-off" : "text-ink"
            }`}
        >
            {formatCurrency(value)}
        </p>
        <span className="text-xs text-faint">{foot}</span>
    </div>
)

export const Totais = ({ repasse }: { repasse: Repasse }) => {
    const repassados = repasse.contratos.filter((c) => c.situacao === "REPASSADO").length
    const pendentes = repasse.contratos.length - repassados

    return (
        <div className="grid gap-px bg-line sm:grid-cols-3">
            <Total
                label="Esperado na guia"
                value={repasse.esperado}
                foot={`${repasse.contratos.length} colaboradores`}
            />
            <Total
                label="Repasse identificado"
                value={repasse.recebido}
                tone="ok"
                foot={
                    repasse.creditoEm
                        ? `${repassados} contratos · crédito em ${repasse.creditoEm}`
                        : `${repassados} contratos`
                }
            />
            <Total
                label="Sem repasse identificado"
                value={repasse.pendente}
                tone="off"
                foot={`${pendentes} ${pendentes === 1 ? "contrato" : "contratos"}`}
            />
        </div>
    )
}
